// Dependency-free CSV export — Excel opens .csv files natively (double-click), so this
// covers "export to Excel" without pulling in a spreadsheet-writing library.
const escapeCell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const BOM = "﻿"; // lets Excel detect UTF-8 correctly (otherwise ₹ and other non-ASCII chars garble)

export const exportToCsv = (filename, headers, rows) => {
  const lines = [headers.map(escapeCell).join(","), ...rows.map((r) => r.map(escapeCell).join(","))];
  const blob = new Blob([BOM + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
